// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__(__webpack_require__.s = "./dist/esm5/index.js");
